import Vue from "vue";
import VueI18n from "vue-i18n";

import moment from "moment";
import { Validator } from "vee-validate";

import ru from "./ru";
import en from "./en";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: "ru",
  fallbackLocale: "en",
  messages: { ru, en }
});

// detect previosly set locale
const lsLocale = localStorage.getItem("locale");

if (lsLocale) {
  i18n.locale = lsLocale;
} else {
  localStorage.setItem("locale", i18n.locale);
}
moment.locale(i18n.locale);
document.title =
  i18n.locale !== "ru"
    ? "Personal Account | EXPOCENTRE"
    : "Личный кабинет | ЭКСПОЦЕНТР";

export function setLocale(locale) {
  i18n.locale = locale;
  moment.locale(locale);
  Validator.localize(locale);
  localStorage.setItem("locale", locale);
}
